export const Techforward = "Techforward";
